import React from 'react';
import { Map, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import CircleMarker from './CircleMarker';

const CampaignLocationMap = (props) => {

    let [center,setCenter] = React.useState({
        lat: 0,
        lng: 0
    });

    React.useEffect(()=>{
        if(props.data && props.data.length > 0){
            const targetLocation = JSON.parse(props.data[0]['target_location']);
            console.log('targetLocation==',targetLocation)
            setCenter({
                lat: targetLocation.latitude,
                lng: targetLocation.longitude
            })
        }
    },[props.data])

    const ZOOM_LEVEL = 5;
    const mapRef = React.useRef();
    const onViewportChanged = (e) => {
    }
    return (
        <div className="row">
            <Map
                closePopupOnClick={false}
                minZoom={ZOOM_LEVEL}
                whenReady={() => { }}
                whenCreated={(map) => {
                }}
                onViewportChanged={onViewportChanged} ref={mapRef}
                center={center}
                zoom={ZOOM_LEVEL}
                scrollWheelZoom={true}
                style={{ border: '1px solid', borderRadius: '5px', height: (props.height) ? props.height : 600, width: (props.width) ? props.width : '100%' }}>
                <TileLayer
                    noWrap={true}
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                <CircleMarker data={props.data} />
            </Map>
        </div>
    );
}
export default CampaignLocationMap;

